export const SIGNIN = "SIGNIN";
export const AUTHENTICATED = "AUTHENTICATED";
export const SIGNOUT = "SIGNOUT";
export const SHOW_AUTH_MESSAGE = "SHOW_AUTH_MESSAGE";
export const AUTH_TOKEN = "auth_token";
export const IS_PASSWORD_SYSTEM_GENERATED = "IS_PASSWORD_SYSTEM_GENERATED";
export const IS_PSUEDO_NAME_SYSTEM_GENERATED = "IS_PSUEDO_NAME_SYSTEM_GENERATED";
export const ACCOUNT_SETUP_COMPLETED = "ACCOUNT_SETUP_COMPLETED";
